<!--
  NavbarDivider Component
  Horizontal divider line between navbar sections.
-->

<script lang="ts">
    // No props needed - purely visual component
</script>

<div class="mx-2 my-2 h-[2px] bg-navbar-divider"></div>
